var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"principal"},[_c('Botao',{attrs:{"type":"button","label":"Relatório","tipo":"primary","callback":_vm.getRelatorioSolicitacoes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }